declare var bDicOnlineCheck: boolean;
declare var submitStopSetting: string;
declare var basketClientId: string;
declare var bSettingsIcoOnlineCheck: boolean;
declare var sPagebaseDelId: string;
declare var fulllang: string;
declare var initializationStep3: boolean;
declare var bPrefillDeliveryAddress: boolean;
declare var hideFields: boolean;

//po prihlaseni promazat localstorage
declare var bClearLocalStorageAfterLogin: boolean;

var xhrDicAjaxValidation1;
var xhrDicAjaxValidation2;
declare var DicAjaxValidationCount: number;
declare var DicAjaxValidationCounter: number;
declare var DicAjaxValidationState: boolean;

declare function SetRequiredFieldsRO(): void;
declare function choocedeliveryadress(checked: boolean): void;
declare function ClearValidationState(o: object): void;
declare function stringToForm(formString: string, Form: object): void;
declare function ClearBasketLocalStorage(): void;
declare function FormBasketSubmit(): void;
function globalRunOnBasket3() {
    if ($('#BasketClient').length === 0) return;
    hideFields = false;
    initializationStep3 = true;
    bPrefillDeliveryAddress = true;

    xhrDicAjaxValidation1 = null;
    xhrDicAjaxValidation2 = null;

    if (bClearLocalStorageAfterLogin) {
        ClearBasketLocalStorage();
    }

    MoveSomeElements();

    //poznamka k objednavce
    PrepareNote();


    $('input[name="sIco"]').bind('focusout', function (e) {
        SetAddressFieldsByDelivery();
        clientIcoCheck();
        SetRequiredFieldsRO();
    });
    $('input[name="sDic"]').bind('focusout', function (e) {
        clientDicCheck();
        SetRequiredFieldsRO();
    })

    $('input[name*="bVatPayer"]').click(function (e) { BindbVatPayer($(this)); });

    if ($('input[name*="bVatPayer"]:checked').length > 0 || site == 3) {
        BindbVatPayer($('input[name*="bVatPayer"]:checked'));
    }

    $('input[name="adresissselect"]').click(function (e) { BindOtherCheckBox($(this)); prefillDeliveryAddress(); $('#adresissselectrf').val($('input[name="adresissselect"]').is(':checked') ? '0' : '1'); });
    BindOtherCheckBox($('input[name="adresissselect"]'));


    $('input[name="b2b_virtual"]').click(function (e) {
        SetAddressFieldsByDelivery();
        BindOtherCheckBox($(this));

        if (site > 1 && !initializationStep3 && !$('input[name="b2b_virtual"]').is(':checked') && bDicOnlineCheck && ($('input[name*="bVatPayer"]').length === 0 || $('input[name*="bVatPayer"]:checked').val() == '1')) {
            toggleVATPrices(false);
        }
        else if (site == 1 && $('input[name="b2b_virtual"]').not(':checked') && $('input[name="bVatPayer"]:checked').val() == '1') {
            $('input[name="bVatPayer"][value="0"]').trigger('click');
        }

        if ($('input[name="b2b_virtual"]').is(':checked')) {
            $('.productBasket__benefits .benefits--item.item-1').html(GetTextDynamic("BasketSum_benefit_1_vatPayer"));
        }
        else {
            $('.productBasket__benefits .benefits--item.item-1').html(GetTextDynamic("BasketSum_benefit_1"));
        }
        SetRequiredFieldsRO();

    });
    BindOtherCheckBox($('input[name="b2b_virtual"]'));


    BindAdressSelect();
    BindAddressSelectRows();

    $('input[name="adressselect"]').click(function (e) { BindAdressSelect(); });

    SetFormByLocalStorage();

    clientIcoCheck();
    clientDicCheck();

    ValidationZipCode();
    UncheckDeliveryAddress();
    SetAddressFieldsByDelivery();

    if ($('input[name="adresissselect"]').length > 0)
        $('#adresissselectrf').val($('input[name="adresissselect"]').is(':checked') ? '0' : '1');
    else if ($('#ucheckAddress').length > 0) {
        var isch = $('#ucheckAddress').is(':checked');
        $('#adresissselectrf').val(isch ? '0' : '1');
    }

    choocedeliveryadress(!$('input[name="adresissselect"]').is(':checked'));
    CopyInvoiceIntoDeliveryForLogged();


    setTimeout(function () {
        ValidationZipCodeCheckDisabled();
    }, 500);


    AfterStringToForm();
 
    if ($('.info--buttons__next.nonactive').length > 0) {
        $('.info--buttons__next.nonactive').click(function (e) { return CheckIfExistsOpenAddresssBox(); });
    }

    if ($('input[name="b2b_virtual"]').is(':checked')) {
        $('.productBasket__benefits .benefits--item.item-1').html(GetTextDynamic("BasketSum_benefit_1_vatPayer"));
    }
    else {
        $('.productBasket__benefits .benefits--item.item-1').html(GetTextDynamic("BasketSum_benefit_1"));
    }

    initializationStep3 = false;

    if ($('body').hasClass('body-basket') && $('.errortitle.emailexist').length > 0) {
        $('html, body').animate({ scrollTop: $('.errortitle.emailexist').offset().top - 200 }, 1000);
    }
}

function SetFormByLocalStorage() {
    if (typeof (Storage) !== 'undefined') {
        var gils = GetItemFromLocalStorage('formStringB');
        stringToForm(gils, $('#FormBasket')); SetTextAreaLength($('.row-sinfo textarea'));

    }
}
function AfterStringToForm() {
    //na strance upozorneni o existujicim emailu - odklikavam registraci
    if ($('.emailexist').length > 0 && $('#basketSumPriceBox input[name="bRegistered"]:checked').length > 0) {
        $('#basketSumPriceBox input[name="bRegistered"]').trigger('click')
    }

    if (!hideFields) {
        if ($('body.notlogged').length > 0) {
            var gils = GetItemFromLocalStorage('formStringB');
            if ((gils == null || gils.indexOf('adresissselect') == -1) && $('input[name="adresissselect"]').length > 0 && $('input[name="adresissselect"]:checked').length == 0) { $('input[name="adresissselect"]').trigger('click'); }
        }
        else if ($('body.logged').length > 0 && $('#ucheckAddress').length == 0) {
            var gils = GetItemFromLocalStorage('formStringB');
            if ((gils == null || gils.indexOf('adresissselect') == -1) && $('input[name="adresissselect"]').length > 0 && $('input[name="adresissselect"]:checked').length == 0) { $('input[name="adresissselect"]').trigger('click'); }
        }
    }



    //pokud se na strance vyskytne hlaseni o tom ze mail existuje a ze nelze registrovat opakovane pak skryvam tuto sekci 
    if ($('.hideregform-action').length > 0) {
        if ($('#basketSumPriceBox input.bRegistered').is(':checked')) {
            $('#basketSumPriceBox input.bRegistered').trigger('click');
        }
        else {
            $('#FormBasket input[name="bRegistered"]').prop('checked', false);
        }
        $('#basketSumPriceBox .new__registration').hide();
    }

}

function BindOtherCheckBox(o) {
    var a = $(o).is(':checked');

    if (a) {
        $(o).parents('label').addClass('active');
    }
    else {
        $(o).parents('label').removeClass('active');
    }

}
function BindbVatPayer(o) {
    if (site == 3) {
        $('.row-sdic').addClass('reguireel');
        $('.row-sdic label').addClass('require');
        $('.row-sdic input').attr('require', 'require');


        if ($(o).is(':checked') && $(o).val() === '1') {
            $('.row-sdic').removeClass('hide');
        } else {
            $('.row-sdic').addClass('hide');
            $('.row-sdic input').val('');
            $('.row-sdic').find('.alert').remove();
            clientDicCheck();
        }
    }

    if ($('.row-bvatpayer label.active').length > 0) $('.row-bvatpayer label.active').removeClass('active');

    if ($(o).is(':checked')) {
        $(o).parents('label').addClass('active');
    }

}
function BindAdressSelect() {
    $('input[name="adressselect"]').each(function (i) {
        if ($(this).is(':checked'))
            $(this).parents('label').addClass('active');
        else
            $(this).parents('label').removeClass('active');
    });
}
function BindAddressSelectRows() {
    $('body.logged .prg-newdeladdr').click(function (e) {
        if ($(this).parents('.addrblock').find('input[type="radio"]').length > 0)
            $(this).parents('.addrblock').find('input[type="radio"]').trigger('click');
    });
}


function MoveSomeElements() {
    var newPlace = $('.productBasket__checkbox');
    var sourcePlace = $('.blokfakturacni .section-for-clone');
    if ($(newPlace).length == 0 || $(sourcePlace).length == 0) return;

    $('.productBasket__checkbox').append($(sourcePlace).html().replaceAll('dynamicformElement', 'dynamicform2Element'));

    //nyni upravy na zkopirovanym blokem

    $(newPlace).find('.row-spassword, .row-password1').each(function (i) { $(this).css('display', ''); $(this).addClass('prg-b2bchangeingnored'); });
    $(newPlace).find('.new__registration').removeClass('hidden');
    $(newPlace).find('.row-bnews').addClass('hidden');

    //ted to nabinduju
    $(newPlace).find('.bregistered').change(function (e) {
        BindNewRegistration();
    });
    BindNewRegistration();

    $(newPlace).find('input[type="checkbox"]:not(".bregistered")').change(function (e) {
        BindUni($(this).attr('name'));
    });

    $(newPlace).find('input[type="checkbox"]:not(".bregistered")').each(function (i) { BindUni($(this).attr('name')); });

    $(newPlace).find('input[name="sPassword"]').change(function (e) { $(sourcePlace).find('input[name="sPassword"]').val($(this).val()); });
    $(newPlace).find('input[name="sPassword1"]').change(function (e) { $(sourcePlace).find('input[name="sPassword1"]').val($(this).val()); });


    if ($(newPlace).find('.bregistered').is(':checked')) {
        $(sourcePlace).find('.bregistered').prop('checked', true);
        $(sourcePlace).find('.new__registration').addClass('active');

    }
    else {
        $(sourcePlace).find('.new__registration').removeClass('active');
        $(sourcePlace).find('.bregistered').prop('checked', false);
    }

}
function BindUni(selName) {
    var newPlace = $('.productBasket__checkbox');
    var sourcePlace = $('.blokfakturacni .section-for-clone');
    if ($(newPlace).find('input[name="' + selName + '"]').is(':checked')) {
        $(sourcePlace).find('input[name="' + selName + '"]').prop('checked', true);
        $(newPlace).find('input[name="' + selName + '"]').parents('.block').addClass('active');
    }
    else {
        $(sourcePlace).find('input[name="' + selName + '"]').prop('checked', false);
        $(newPlace).find('input[name="' + selName + '"]').parents('.block').removeClass('active');
        $(newPlace).find('input[name="' + selName + '"]').parents('label').removeClass('active');
    }
}

function PrepareNote() {
    if ($('.row-sinfo').length === 0) return;

    //pridame htmlkod pro pocitadlo delky textu
    if ($('.row-sinfo .note-length').length == 0)
        $('.row-sinfo').append("<p class='note-length'><span class='from'>" + $('textarea.sinfo').val().toString().length + "</span>/<span class='to'>" + $('textarea.sinfo').attr('maxlength') + "</span></p>");

    BindNote();
    $('input[name="bRegFeePaid"]').click(function (e) {
        BindNote();
    });
    SetTextAreaLength($('.row-sinfo textarea'));

    $('.row-sinfo textarea').bind('keyup', function (e) {
        SetTextAreaLength($(this));
    });
}
function BindNote() {
    var on = $('input[name="bRegFeePaid"]').is(':checked');
    if (on) {
        $('textarea.sinfo').attr('require', 'require');
        $('.row-sinfo label').addClass('require');
        $('.bl--2--info').addClass('active');
    }
    else {
        $('textarea.sinfo').removeAttr('require');
        $('.row-sinfo label').removeClass('require');
        $('.bl--2--info').removeClass('active');
        $('input[name="bRegFeePaid"]').parents('label').removeClass('active');
        ClearValidationState($('textarea.sinfo'));
    }
}

function SetTextAreaLength(el) {
    var l = $(el).val().length;
    var max = $(el).attr('maxlength');
    var p = $(el).parents('.block');
    $(p).find('.note-length > .from').html(l);
    if (l < max) {
        $(p).removeClass('warning');
        if (l > 0) ClearValidationState($(el));
    }
    else {
        $(p).addClass('warning');
    }
}

//nova registrace   
function BindNewRegistration() {
    var newPlace = $('.productBasket__checkbox');
    var sourcePlace = $('.blokfakturacni .section-for-clone');
    if ($(newPlace).find('.bregistered').is(':checked')) {
        $(sourcePlace).find('.bregistered').prop('checked', true);
        $(newPlace).find('.new__registration').addClass('active');
        $(newPlace).find('.new__registration').addClass('active');
    }
    else {
        $(newPlace).find('.new__registration').removeClass('active');
        $(newPlace).find('.bregistered').parents('label').removeClass('active');
        $(sourcePlace).find('.bregistered').prop('checked', false);
    }
}

function ExternalDeliveryUserForm() {
    if ($('.ul-delivery li.external-method.active').length > 0) {
        if ($(".adresstype-delivery-0-8").length > 0) { $(".adresstype-delivery-0-8").addClass("element-hide"); }

        if ($(".blokfakturacni .row-sstreet").length > 0) { $(".blokfakturacni .row-sstreet").addClass("element-hide"); }
        if ($(".blokfakturacni .row-sstreethouseno").length > 0) { $(".blokfakturacni .row-sstreethouseno").addClass("element-hide"); }
        if ($(".blokfakturacni .row-scity").length > 0) { $(".blokfakturacni .row-scity").addClass("element-hide"); }
        if ($(".blokfakturacni .row-szipcode").length > 0) { $(".blokfakturacni .row-szipcode").addClass("element-hide"); }
        if ($(".blokfakturacni .row-fktblcountry").length > 0) { $(".blokfakturacni .row-fktblcountry").addClass("element-hide"); }
    }
    else {
        if ($(".adresstype-delivery-0-8").length > 0) { $(".adresstype-delivery-0-8").removeClass("element-hide"); }

        if ($(".blokfakturacni .row-sstreet").length > 0) { $(".blokfakturacni .row-sstreet").removeClass("element-hide"); }
        if ($(".blokfakturacni .row-sstreethouseno").length > 0) { $(".blokfakturacni .row-sstreethouseno").removeClass("element-hide"); }
        if ($(".blokfakturacni .row-scity").length > 0) { $(".blokfakturacni .row-scity").removeClass("element-hide"); }
        if ($(".blokfakturacni .row-szipcode").length > 0) { $(".blokfakturacni .row-szipcode").removeClass("element-hide"); }
        if ($(".blokfakturacni .row-fktblcountry").length > 0) { $(".blokfakturacni .row-fktblcountry").removeClass("element-hide"); }
    }
}


function SetAddressFieldsByDelivery() {
    if ($('.not-for-external-delivery').length == 0) return;
    var hideByDel = ($('#hSelDelWithoutAddress').length > 0 && $('#hSelDelWithoutAddress').val() === '1');

    var icoFilled = ($('.row-sico input.sico').length > 0 && $('.row-sico input.sico').val() !== '');
    if (!icoFilled) icoFilled = ($('.row-sdic input.sdic').length > 0 && $('.row-sdic input.sdic').val() !== ''); //ico nebo dic

    var isB2B = ($('.b2b_virtual').length > 0 && $('.b2b_virtual').is(':checked'));

    if (!isB2B) icoFilled = false;

    hideFields = (hideByDel && !icoFilled);

    // pokud existuje sekce pro spolecny vyber mesta a psc "row-szipcode-city" pak prestanu resit tridu Hidden u sekci row-scity a row-szipcode
    var ignoreCityZipCode = ($('.row-szipcode-city').length > 0);
    $(".not-for-external-delivery").each(function (index, item) {
        var o = ($(this).find('select').length > 0 ? $(this).find('select') : $(this).find('input'));
        if (hideFields) {
            $(this).addClass('hidden');
            if ($(this).hasClass('reguireel')) { $(this).addClass('xreguireel'); $(this).removeClass('reguireel') }
            if ($(o)) {

                if ($(o).attr('require') !== undefined) {
                    $(o).attr('xrequire', $(o).attr('require'));
                    $(o).removeAttr('require');
                }
            }
        }
        else {
            if (!ignoreCityZipCode || (!$(this).hasClass('row-scity') && !$(this).hasClass('row-szipcode'))) {
                //if (!$(this).hasClass('deliveryadress')) {
                $(this).removeClass('hidden');
                // }
            }

            if ($(this).hasClass('xreguireel')) { $(this).addClass('reguireel'); $(this).removeClass('xreguireel') }
            if ($(o)) {

                if ($(o).attr('xrequire') !== undefined) {
                    $(o).attr('require', $(o).attr('xrequire'));
                    $(o).removeAttr('xrequire');
                }
            }
        }

    });

    if (hideFields) {

        // zaskrtnu stejna jako fakturacni - notlogged
        if ($('.notlogged input[name="adresissselect"]').length > 0 && !$('.notlogged input[name="adresissselect"]').is(':checked')) {
            $('.notlogged input[name="adresissselect"]').trigger('click');
        }
        else if ($('.logged  input[name="ucheckAddress"]').length > 0 && !$('.logged  input[name="ucheckAddress"]').is(':checked')) { //prihl vice adres
            $('#ucheckAddress').trigger('click');
        }
        else if ($('.logged  input[name="ucheckAddress"]').length == 0 && $('.logged input[name="adresissselect"]').length == 1 && !$('.logged input[name="adresissselect"]').is(':checked')) {
            $('.logged input[name="adresissselect"]').trigger('click');
        }
        saveadress("del", '0', '0', null);
    }
}

function toggleVATPrices(toVAT) {
    try {
        bsiRecalcVat = '&setVAT=' + (toVAT ? 'true' : 'false');

        if (toVAT) {
            $('body').removeClass('notvatpayer').addClass('vatpayer');
        }
        else {
            $('body').removeClass('vatpayer').addClass('notvatpayer');
        }
        refreshBasket(toVAT);
    }
    catch (err) { console.log(err); }
}


//validace psc a mesta
function ValidationZipCode() {
    if (!$("body").hasClass("basket-cd") && $(".row--szipcode-city").length > 0) {

        $("<select class='szipcode-city-select'></select>").insertAfter(".szipcode-city");
        $(".szipcode-city").hide();

        $(".szipcode-city-select").select2({
            placeholder: "",
            minimumInputLength: 1,
            allowClear: false,
            ajax: {
                // @ts-ignore
                transport: function (params: any, success: any, failure: any) {
                    return $.ajax({
                        url: params.url,
                        type: params.type,
                        data: params.data,
                        contentType: 'application/json; charset=utf-8',
                        dataType: params.dataType,
                        success: success,
                        error: failure
                    });
                },
                url: "/Services/EShopService.svc/GetZIPCities",
                dataType: 'json',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                delay: 400,
                data: function (params: any) {
                    return JSON.stringify({
                        searchString: params.term ?? "",
                        nPage: params.page ?? 1
                    });
                },
                processResults: function (data, params) {
                    var data2 = JSON.parse(data.Value);
                    return {
                        results: data2.items,
                        pagination: {
                            more: data2.more
                        }
                    };
                },
                headers: { "cache-control": "no-cache" },
                cache: true
            },
            templateResult: function (data) {
                return data.name ?? data.text ?? "";
            },
            templateSelection: function (data) {
                return data.name ?? data.text ?? "";
            },
            dropdownCssClass: "bigdrop",
            escapeMarkup: function (m) { return m; },
            language: {
                noResults: function () {
                    return GetTextDynamic("registration_form_select2zipcode_noResults"); // "Nenašli sa žiadne položky.";
                },
                inputTooShort: function (args) {
                    return GetTextDynamic("registration_form_select2zipcode_inputTooShort"); //"Zadajte prosím ešte jeden znak.";
                },
                loadingMore: function () {
                    return GetTextDynamic("registration_form_select2zipcode_loadingMore"); //"Načítavajú sa ďalšie výsledky...";
                },
                searching: function () {
                    return GetTextDynamic("registration_form_select2zipcode_searching"); //"Vyhľadávanie...";
                }
            }
        });

        $(".szipcode-city-select").each(function () {
            var wrap = $(this).closest('.block');
            var id = $(wrap).find(".zipcode-sel2").val();
            var name = $(wrap).find(".city-sel2").val();

            if (id && name) {
                $.ajax({
                    type: "POST",
                    contentType: "application/json; charset=utf-8",
                    url: "/Services/EShopService.svc/GetZIPCities",
                    data: JSON.stringify({
                        searchString: id,
                        nPage: 1,
                        searchStringAdd: name
                    }),
                    dataType: "json",
                    success: function (data) {
                        if (data === "null") return;
                        var data2 = JSON.parse(data.Value).items[0];
                        if (data2) {
                            var option = new Option(data2.name, data2.id, true, true);
                            $(wrap).find(".szipcode-city-select").append(option).trigger('change');

                            const rawName = data2.name ?? data2.text ?? "";
                            name = rawName.replace(id + ' - ', '');
                            $(wrap).find(".city-sel2").val(name);
                        }
                    }
                });
            }
        });

        $(".szipcode-city-select").on("select2:close", function (e) {
            const data = $(this).select2('data');
            let id = "";
            let name = "";

            if (data && data.length > 0) {
                id = data[0].id;

                const rawName = data[0].name ?? data[0].text ?? "";
                name = rawName.replace(id + ' - ', '');

                $(this).parent().find(".isrequire").remove();
                $(this).closest(".block").removeClass("is-not-valid").removeClass("error").addClass("is-valid").addClass('success');
            }

            $(this).parent().find(".zipcode-sel2").val(id);
            $(this).parent().find(".city-sel2").val(name);
        });


        var wasChecked = false;

        $(".deliveryadress input[name*='adressselect']").each(function () {
            var thisElement = $(this);
            var p = $(thisElement).parents('.addrblock');

            var id = $(p).find(".row-scity-szipcode").find("input[name*='sZipCode']").val();
            var name = $(p).find(".row-scity-szipcode").find("input[name*='sCity']").val();
            if (id !== "") {
                $.ajax({
                    type: "POST",
                    async: false,
                    contentType: "application/json; charset=utf-8",
                    url: "/Services/EShopService.svc/GetZIPCities",
                    data: JSON.stringify({ "searchString": id, "nPage": "1", "searchStringAdd": name, "strictMode": "1" }),
                    dataType: "json",
                    success: function (data) {
                        var data2 = JSON.parse(data.Value).items[0];

                        if (typeof data2 === 'undefined') {
                            $(p).append("<div class='block alert alert-danger isrequire_delivery'>" + GetTextDynamic("registration_form_novalid_zip_to_city") + "</div>");
                            //     thisElement.prop("checked", false);
                            thisElement.prop("disabled", true);

                            if ($(thisElement).is(':checked')) {
                                wasChecked = true;
                            }

                        }
                    }
                });
            }
        });


    }
}
function ValidationZipCodeCheckDisabled() {
    if (!$("body").hasClass("basket-cd") && $(".row--szipcode-city").length > 0) {
        if ($(".deliveryadress input[name*='adressselect']:checked").length > 0 && $(".deliveryadress input[name*='adressselect']:checked").is(':disabled') && $("#ucheckAddress").length > 0) {
            $("#ucheckAddress").trigger('click');
        }
    }
}

//function ClearSelectBox2(e) {
//    $(e).parents('.block').find(".szipcode-city").select2('data', null);
//    $(e).remove();
//}
function addDeliveryAddressRemoveButtonAction(target) {
    $("#FormBasket").attr("action", target);
    addDeliveryAddressResetButtonAction();
}

function addDeliveryAddressResetButtonAction() {
    $("#FormBasket").find("input:visible, select:visible, textarea:visible").hide();
    $("input[name='sendorder'], input[name='save']").val(0);
    $("input[name='newdelivery']").val(0);
    addDeliveryAddressHiddenInput();
    FormBasketSubmit();
}

function addDeliveryAddressResetButtonActionR() {
    var url = window.location.href;
    window.location.replace(url);
}
function addDeliveryAddressHiddenInput() {
    $("#FormBasket").append($('<input type="hidden" name="addingnewdeliveryaddress" value="1" />'));
}


function clientIcoCheck() {
    var input = $('#FormBasket input[name=sIco]');
    if ($(input).length === 0) return false;
    var p = $(input).parents('.block');
    var v = $(input).val().toString().trim();
    var data = {};

    var isError = false;

    if (v.length > 0) {
        data = { 'basket': basketClientId };

        $(input).find('.coupon-error').remove();

        if ($(p).find('.preload').length == 0)
            $(input).after("<p class='alert alert-input alert-info preload'><img src='/ImgGalery/Base/ajax-loader-small.gif' /></p>");

        $.ajax({
            type: "GET",
            url: "/Ajax/basketCouponCheck.aspx",
            data: data,
            async: false,
            success: function (data) {
                $(p).find('.coupon-error').remove();

                if (data.toString().length > 5) {
                    isError = true;
                    $(input).after("<p class='coupon-error alert alert-input ajax'>" + data + "</sppan>");
                }
            },
            complete: function () {
                $(p).find('.preload').remove();
            }
        });
    }

    //online validace ICO
    if (bSettingsIcoOnlineCheck) {
        $(input).find('.not-validico, .is-validico').remove();
        if (v.length > 7) {
            if ($(p).find('.preload').length == 0)
                $(this).after("<span class='ico-loader'><img src='/ImgGalery/Base/ajax-loader-small.gif' /></span>");

            data = { ico: v };
            EshopService('AresFind', data, false, function (result) {
                $(p).find('.preload').remove();

                if (result.ErrorLevel > 0) {
                    isError = true;
                    $(input).after('<p class=\"alert alert-input not-validico ajax\">' + GetTextDynamic("registration_form_validico") + '</p>');
                }
                else if (result.ErrorLevel == 0) {
                    var jdata = JSON.parse(result.Message);
                    $(input).after('<p class=\"alert alert-input alert-success is-validico ajax\">' + GetTextDynamic("registration_valid_ic") + '<span>' + jdata.Info.ObchodniFirma + ' ' + jdata.Info.AdresaAres.Ulice + ' ' + jdata.Info.AdresaAres.CisloPopisne + ' ' + jdata.Info.AdresaAres.Obec + ' ' + jdata.Info.AdresaAres.PSC + '</span></p>');
                }
            });
        }
        else if (v.length > 0) {
            isError = true;
            $(input).after('<p class=\"alert alert-input alert-danger not-validico ajax\">' + GetTextDynamic("registration_form_validico") + '</p>');
        }
    }


    if (isError) {
        $(p).addClass('error');
    }
    else if ($(p).find('.alert').not('.ajax').length == 0 && !initializationStep3) {
        $(p).removeClass('error').addClass('success');
    }

}
function clientDicCheckCallback(p) {
    if (DicAjaxValidationCounter == DicAjaxValidationCount) {
        $(p).find('.preload').remove();

        if (DicAjaxValidationState) {
            $(p).addClass('error');
        }
        else if ($(p).find('.alert').not('.ajax').length == 0 && !initializationStep3) {
            $(p).removeClass('error').addClass('success');
        }
    }
}

function clientDicCheck() {
    var input = $('#FormBasket input[name=sDic]');
    if ($(input).length === 0) return false;
    var p = $(input).parents('.block');
    var v = $(input).val().toString().trim();
    var data = {};

    DicAjaxValidationState = false;
    DicAjaxValidationCounter = 0;
    if (v.length > 0) {
        DicAjaxValidationCount = 0;
        if (xhrDicAjaxValidation1 != null) xhrDicAjaxValidation1.abort();
        if (xhrDicAjaxValidation2 != null) xhrDicAjaxValidation2.abort();

        if (bDicOnlineCheck && ($('input[name*="bVatPayer"]').length === 0 || $('input[name*="bVatPayer"]:checked').val() == '1')) {
            DicAjaxValidationCount++;
            var submitStop = submitStopSetting;
            var elementType = $(input).attr('type').toLowerCase();
            if (submitStop == '1' && elementType == 'hidden') { submitStop = '0'; }

            var submitStop = submitStopSetting;
            var elementType = $(input).attr('type').toLowerCase();
            if (submitStop == '1' && elementType == 'hidden') { submitStop = '0'; }

            $(input).find('.dic-error').remove();

            if ($(p).find('.preload').length == 0)
                $(input).after("<p class='alert alert-input alert-info preload'><img src='/ImgGalery/Base/ajax-loader-small.gif' /></p>");

            data = { 'dic': v, 'submitStop': submitStop };
            var url = "/Ajax/clientDicCheck.aspx?b=1&lang=" + fulllang;
            xhrDicAjaxValidation1 = $.ajax({
                type: "GET",
                url: url,
                data: data,
                success: function (data) {
                    if (data.indexOf('alert-danger') >= 0) DicAjaxValidationState = true;
                    $('.isvaliddic').remove();
                    $(input).after(data);
                },
                complete: function () {
                    DicAjaxValidationCounter++;
                    clientDicCheckCallback(p);
                }
            });


            ///////////////////////////////////////

            //data = { 'basket': basketClientId };

            //$(input).find('.coupon-error').remove();

            //if ($(p).find('.preload').length == 0)
            //    $(input).after("<p class='alert alert-input alert-info preload'><img src='/ImgGalery/Base/ajax-loader-small.gif' /></p>");

            //xhrDicAjaxValidation2 = $.ajax({
            //    type: "GET",
            //    url: "/Ajax/basketCouponCheck.aspx",
            //    data: data,
            //    success: function (data) {
            //        $(p).find('.coupon-error').remove();

            //        if (data.toString().length > 5) {
            //            DicAjaxValidationState = true;
            //            $(input).after("<p class='coupon-error alert alert-input ajax'>" + data + "</sppan>");
            //        }
            //    },
            //    complete: function () {
            //        DicAjaxValidationCounter++;
            //        clientDicCheckCallback(p);
            //    }
            //});
        }
    }
    else if (site > 1 && bDicOnlineCheck && ($('input[name*="bVatPayer"]').length === 0 || $('input[name*="bVatPayer"]:checked').val() == '0')) {
        toggleVATPrices(false);
    }
}



function ZipCodeIsNotBlocked(inputZip) {
    var onPageDelId = null;
    var delId = null;
    var returnValue = true;
    var radioValue = $("input[name='delpaymentD']:checked").val();
    if (radioValue) {
        onPageDelId = radioValue;
    }
    if (onPageDelId !== null) {
        delId = onPageDelId;
    }
    else if (sPagebaseDelId !== null) {
        delId = sPagebaseDelId;
    }
    else {
        delId = 0;
    }
    EshopService("IsZipBlockedCheck", { sZIP: inputZip, delId: delId }, false, function (result) {
        if (result.Message === 'True') {
            returnValue = false;
        }
    });

    //console.log('ZipCodeIsNotBlocked = ' + returnValue)
    return returnValue;
}

function UncheckDeliveryAddress() {

    var tlDesc = GetTextDynamic("basket_client_inv_address");
    if ($('body.logged').length > 0 && $('.deliveryadress').length > 0 && $('.deliveryadress').hasClass('more-adress') && tlDesc !== "" && tlDesc !== "#" && $('.adresstype-delivery-0-8 .savedata').length == 0) {

        var html = "<div class='div-start adresstype-fakturacni inp_validation'><div class='deliveryadressselect'><label " + ($('input[name="adressselect"]:checked').length > 0 ? "" : "class='active'") + "><input type='radio' id='ucheckAddress' name='ucheckAddress' " + ($('input[name="adressselect"]:checked').length > 0 ? "" : "checked='checked'") + " />" + tlDesc + "</label></div></div>";
        $(".more-adress .div-start").eq(0).before(html);
        $('input[name="adressselect"]').click(function () {
            $('#ucheckAddress').prop("checked", false).removeAttr("checked");
            $('#ucheckAddress').parents('label').removeClass('active');
            $('#adresissselectrf').val('1');
        });

        $('#ucheckAddress').click(function () {
            $('#ucheckAddress').parents('label').addClass('active');
            $('#adresissselectrf').val('0');
            $('input[name="adressselect"]').removeData("chk");
            $('input[name="adressselect"]').prop("checked", false);
            $('input[name="adressselect"]').removeAttr("checked");
            $('.more-adress .activ-del').removeClass('activ-del');
            BindAdressSelect();
            saveadress("del", '0', '0', $(this));
        });

        //inicializace - pokud neni del adress vybrano tak 
        if ($('#ucheckAddress:checked').length > 0)
            saveadress("del", '0', '0', $(this));
    }
}
function prefillDeliveryAddress() {
    if (!bPrefillDeliveryAddress) return;
    bPrefillDeliveryAddress = false;
    var inv = ['sfirm', 'sFirstName', 'sLastName', 'sStreet', 'sStreetHouseNo', 'sZipCode', 'sCity'];
    var del = ['sfirm', 'sfirstname', 'slastname', 'sstreet', 'sstreethouseno', 'szipcode', 'scity'];

    var isEmpty = true;
    $(del).each(function (i, v) {
        if ($('.deliveryadress .' + v).length > 0 && $('.deliveryadress .' + v).val() !== '') {
            isEmpty = false; return;
        }
    });
    var isEmptyInv = true;
    $(inv).each(function (i, v) {
        if ($('.blokfakturacni .' + v).length > 0 && $('.blokfakturacni .' + v).val() !== '') {
            isEmptyInv = false;
        }
    });

    if (!bPrefillDeliveryAddress && isEmpty && isEmptyInv)
        bPrefillDeliveryAddress = true;

    if (isEmpty) {
        $(inv).each(function (i, v) {
            if (v.toString() != "" && $('.blokfakturacni  input[name="' + v + '"] ').length > 0 && $('.deliveryadress .' + del[i]).length > 0) {
                $('.deliveryadress .' + del[i]).val($('.blokfakturacni input[name="' + v + '"] ').val());
            }
        });

        if (site == 6)//ro
        {
            $('.deliveryadress .fktblcountry').val($('.blokfakturacni .fktblcountry').val()).change();
            setTimeout(function () { $('.deliveryadress .fktblcountryregion').val($('.blokfakturacni .fktblcountryregion').val()).change(); }, 500);

        }
    }

    setTimeout(function () { ZipIsAllowedAll(); }, 220);

}
function CopyInvoiceIntoDeliveryForLoggedBind() {
    if ($('body.logged').length == 0 || $('.for-copy-phone').length == 0) return;

    $('.blokfakturacni input[name="sPhone"], .blokfakturacni input[name="sEmail"]').change(function (e) {
        CopyInvoiceIntoDeliveryForLogged();
    });
    CopyInvoiceIntoDeliveryForLogged();
}
function CopyInvoiceIntoDeliveryForLogged() {

    $('.for-copy-phone').each(function (i) {
        $(this).find('span').html($('.blokfakturacni input[name="sPhone"]').val().toString());
    });
    $('.for-copy-email').each(function (i) {
        $(this).find('span').html($('.blokfakturacni input[name="sEmail"]').val().toString());
    });
}




// pokud jsem prihlaseny nejakou adr jiz mmam a otevru zadani nove adresy pak se mi navigacni tlacko pro odeslani objednavky zneaktivnuje
function CheckIfExistsOpenAddresssBox() {
    var rv = true;
    if ($('body.logged').length > 0 && $('.newadress').length > 0) {

        $('html, body').animate({
            scrollTop: $(".deliveryadress").offset().top
        }, 250);
        rv = false;
    }
    return rv;
}


